import {BaseModel} from "./base-model";
import {BaseViewModel} from "./base-view-model";
import {AppTerms} from "../../core/app/app-terms";

export class BaseMetadataModel extends BaseModel {
  model: BaseViewModel;
  terms: AppTerms;

  constructor(model: BaseViewModel, terms: AppTerms) {
    super(model);

    this.model = model;
    this.terms = terms;
  }

  get alt(): String {
    return this.model.name;
  }

  get title(): String {
    return this.model.name;
  }

  get description(): String {
    return this.model.name;
  }
}
